import type { WeatherAlert } from "../../shared/models";
import { Icon } from "../ui/Icon";
import { alertKind } from "../../shared/alerts";
import { KIND_ICON, toneOf, untilText } from "../widgets/alerts/alertUi";
import { useHousehold } from "./useHousehold";

/** A bright strip across every screen while a warning or any fire-weather alert is active. */
export function AlertBar({ alerts, onOpen }: { alerts: WeatherAlert[]; onOpen: () => void }) {
  const { timeZone, settings } = useHousehold();
  const first = alerts[0]!;
  const until = untilText(first, timeZone, settings.clock24h);
  return (
    <button className={`alert-bar tone-${toneOf(first)}`} onClick={onOpen} role="alert">
      <Icon name={KIND_ICON[alertKind(first.event)]} size="1.35rem" />
      <strong>{first.event}</strong>
      {until && <span>{until}</span>}
      {alerts.length > 1 && <span className="alert-bar-more">+{alerts.length - 1} more</span>}
      <span className="alert-bar-cta">
        Details <Icon name="chevronRight" size="1rem" />
      </span>
    </button>
  );
}
